import React from 'react'
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Add from '@mui/icons-material/Add';

import { RedirectForm } from './RedirectForm.js';
import { TriggerForm } from './TriggerForm.js';
import { FormType } from './FormType.js';
import { ensureArray } from '../../../../utils/validateResponseApi.js';

export const ManageActions = ({ values, errorInputs, listActions, handleInputChange, handleDirectInputChange, handleAdd, t }) => {
    const handleRedirectData = React.useCallback((obj) => {
        handleDirectInputChange('config', obj);
    }, [handleDirectInputChange])

    const handleTriggerData = React.useCallback((obj) => {
        handleDirectInputChange('trigger', obj);
    }, [handleDirectInputChange])

    const handleFormdData = React.useCallback((obj) => {
        handleDirectInputChange('form', obj);
    }, [handleDirectInputChange])

    return (
        <Box>
            <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                <Grid size={{xs:10, sm:10}}>
                    <Typography variant='h6' component='h6'>{t("common.actions")}</Typography>
                </Grid>
                {listActions &&
                    <Grid                         
                        size={{xs:2, sm:'auto'}}         
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                            gap: 1
                        }}
                    >
                        <Tooltip title={t("add")}>
                            <IconButton onClick={handleAdd}>
                                <Add />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                }
            </Grid>

            <Grid container spacing={2}>
                <Grid size={{xs:12, sm:6}}>
                    <TextField fullWidth required size="small" variant="outlined" name="accion" label="Acción"
                        value={values?.accion || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.accion?.isError}
                        helperText={errorInputs.accion?.messageError}
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField required fullWidth size="small" variant="outlined" name="icon" label="Icono"
                        value={values?.icon || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.icon?.isError}
                        helperText={errorInputs.icon?.messageError}
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField required fullWidth size="small" variant="outlined" name="color" label="Color"
                        value={values?.color || ''}
                        onChange={handleInputChange}
                        error={!!errorInputs.color?.isError}
                        helperText={errorInputs.color?.messageError}
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <FormControl fullWidth required size="small"
                        error={Boolean(errorInputs.type?.isError)}
                    >
                        <InputLabel id="type">{t('commonFields.type')}</InputLabel>
                        <Select name="type" label="Tipo"
                            value={values?.type || ''}
                            onChange={handleInputChange}
                        >
                            <MenuItem value="Redirect" sx={{ fontWeight: 'bold' }}>
                                Redirect
                            </MenuItem>
                            <MenuItem value="form" sx={{ fontWeight: 'bold' }}>
                                Form
                            </MenuItem>
                            <MenuItem value="trigger" sx={{ fontWeight: 'bold' }}>
                                Trigger
                            </MenuItem>
                        </Select>
                        {errorInputs.type?.isError && <FormHelperText>{errorInputs.type.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    {values?.type === 'Redirect' && (
                        <RedirectForm
                            values={values?.config || {}}
                            onFieldsChange={handleRedirectData}
                        />
                    )}

                    {values?.type === 'form' && (
                        <FormType
                            values={values?.form || []}
                            onFieldsChange={handleFormdData}
                            t={t}
                        />
                    )}

                    {(values?.type === 'form' || values?.type === 'trigger') && (
                        // <TriggerForm
                        //     values={
                        //         Array.isArray(values?.trigger)
                        //             ? values.trigger[0] || {}
                        //             : {}
                        //     }
                        //     errorInputs={{}}
                        //     onFieldsChange={handleTriggerData}
                        //     t={t}
                        // />
                        <TriggerForm values={ensureArray(values?.trigger)[0]} errorInputs={{}} onFieldsChange={handleTriggerData} t={t} />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}
